export default "__VITE_ASSET__CXw9BfZx__"